<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-h8`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 6a1 1 0 00-1-1H3a1 1 0 00-1 1v36a1 1 0 001 1h2a1 1 0 001-1V26h17v16a1 1 0 001 1h2a1 1 0 001-1V6a1 1 0 00-1-1h-2a1 1 0 00-1 1v16H6V6zm37 12.797c-1.355-1.344-3.142-2.016-5.331-2.016-2.178 0-3.948.657-5.282 1.974-1.331 1.314-2.002 2.947-2.002 4.87 0 1.282.318 2.399.957 3.336.44.645 1.038 1.184 1.787 1.619a6.041 6.041 0 00-2.432 1.976c-.843 1.17-1.262 2.612-1.262 4.312 0 2.278.765 4.198 2.288 5.73 1.526 1.537 3.535 2.305 5.994 2.305 2.46 0 4.467-.765 5.994-2.295C45.234 39.081 46 37.186 46 34.952c0-1.62-.407-3.028-1.225-4.211-.621-.9-1.456-1.611-2.498-2.131.757-.439 1.361-.986 1.807-1.642.633-.93.95-2.02.95-3.26 0-1.922-.682-3.569-2.034-4.91zm-5.347 11.654c-1.23 0-2.229.415-3.03 1.255-.806.845-1.207 1.895-1.207 3.179 0 .785.178 1.543.537 2.281a3.744 3.744 0 001.547 1.656 4.452 4.452 0 002.25.597c1.253 0 2.267-.411 3.073-1.241.809-.833 1.212-1.887 1.212-3.192 0-1.327-.416-2.404-1.251-3.259-.834-.853-1.867-1.276-3.131-1.276zM35.3 21.224c.635-.642 1.425-.96 2.4-.96.962 0 1.749.325 2.39.983.643.66.961 1.466.961 2.445 0 .933-.307 1.706-.93 2.344-.617.634-1.403.948-2.389.948-1.018 0-1.823-.318-2.445-.956-.626-.642-.938-1.467-.938-2.504 0-.897.313-1.655.951-2.3z"/></svg>
</template>
<script>

export default {
  name: 'IconH8',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
